<template>
  <div>
    <md-button class="md-icon-button md-dense refresh-btn" @click="toggleIsActive">
      <md-tooltip md-direction="top">Search</md-tooltip>
      <md-icon>search</md-icon>
    </md-button>

    <!--  menu part  -->
    <transition name="fade">
      <div class="menu" v-if="isActive">
        <div class="md-layout md-alignment-center-left">
          <div>
            <div style="min-width: 45vw; max-width: 58vw">
              <div class="result" @click="openMenu">
                <div v-for="(item, index) in result" :key="index" class="result-item">
                  <div class="result-item-body" :style="{ 'background-color': secondaryColor }">
                    <span v-if="item.leftOperand">{{ item.leftOperand }}</span>
                    <span v-if="item.operator">{{ item.operator }}</span>
                    <span v-if="item.rightOperand">{{ item.rightOperand }}</span>
                    <button @click.stop="removeResultItem(item)" class="round-button delete-button">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="times"
                        class="svg-inline--fa fa-times fa-w-11"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 352 512"
                      >
                        <path
                          fill="currentColor"
                          d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                        />
                      </svg>
                    </button>
                  </div>
                  <span class="result-item-next" v-if="item.next">
                    {{ item.next }}
                    <button
                      v-if="index === result.length - 1"
                      @click.stop="removeLastConjunction"
                      class="round-button delete-button"
                    >
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="times"
                        class="svg-inline--fa fa-times fa-w-11"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 352 512"
                      >
                        <path
                          fill="currentColor"
                          d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                        />
                      </svg>
                    </button>
                  </span>
                </div>
              </div>
              <div class="menu-container">
                <!--      Operands menu-->
                <div :class="[showOperandsMenu ? 'operand-menu show' : 'hide']">
                  <ul>
                    <li
                      v-for="(operand, index) in currentOperands"
                      @click.prevent="calculateResult('operand', operand)"
                    >
                      {{ operand }}
                    </li>
                  </ul>
                </div>
                <!--      Operator menu-->
                <transition name="fade">
                  <div :class="[showOperatorsMenu ? 'operand-menu show' : 'hide']">
                    <ul>
                      <li
                        v-for="(operator, index) in currentOperators"
                        @click.prevent="calculateResult('operator', operator)"
                      >
                        {{ operator }}
                      </li>
                    </ul>
                  </div>
                </transition>
                <!--      Value menu-->
                <transition name="fade">
                  <div :class="[showValueMenu ? 'show' : 'hide']">
                    <div class="value-menu">
                      <md-field class="md-layout-item md-small-size-100 md-size-100">
                        <label>Search Value</label>
                        <md-input
                          ref="valueElement"
                          v-model="valueModel"
                          @keyup.enter="calculateResult('value', valueModel)"
                          required
                        ></md-input>
                      </md-field>
                      <div>
                        <md-button class="md-primary md-raised" @click="calculateResult('value', valueModel)"
                          >{{ submitBtnText }}
                        </md-button>
                      </div>
                    </div>
                  </div>
                </transition>
                <!--And / Or-->
                <transition name="fade">
                  <div :class="[showAndOrMenu ? 'operand-menu show' : 'hide']">
                    <ul>
                      <li @click.prevent="calculateResult('ANDOR', 'AND')">AND</li>
                      <li @click.prevent="calculateResult('ANDOR', 'OR')">OR</li>
                    </ul>
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <div class="md-layout-item">
            <md-button style="height: 48px" class="md-primary md-raised" @click="doSearch">search</md-button>
          </div>
          <button
            v-if="result.length"
            @click.stop="
              result = [];
              closeMenu();
              doSearch();
            "
            class="round-button clear-button"
          >
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="times"
              class="svg-inline--fa fa-times fa-w-11"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 352 512"
            >
              <path
                fill="currentColor"
                d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
              />
            </svg>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, watch } from "@vue/composition-api";

export default {
  name: "VueSelectSearch",
  props: {
    operands: {
      type: Array,
      default: () => [],
    },
    operators: {
      type: Array,
      default: () => [],
    },
    submitBtnText: {
      type: String,
      default: "SUBMIT",
    },
    primaryColor: {
      type: String,
      default: "#9c27b0",
    },
    secondaryColor: {
      type: String,
      default: "#e8e8e8",
    },
    forceClose: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const currentOperands = ref([]);
    watch(
      () => props.operands,
      (oldOperands, newOperands) => {
        currentOperands.value = [...new Set([...currentOperands.value, ...props.operands])];
      }
    );
    const showOperandsMenu = ref(false);

    const currentOperators = ref([]);
    watch(
      () => props.operators,
      (oldOperators, newOperators) => {
        currentOperators.value = [...new Set([...currentOperators.value, ...props.operators])];
      }
    );
    const showOperatorsMenu = ref(false);

    const showValueMenu = ref(false);
    const valueModel = ref("");
    const valueElement = ref(null);
    const result = ref([]);

    const showAndOrMenu = ref(false);
    const openMenu = () => {
      closeMenu();
      if (
        result.value.length === 0 ||
        (result.value.at(-1).operator && result.value.at(-1).rightOperand && result.value.at(-1).next)
      ) {
        showOperandsMenu.value = true;
      } else if (result.value.at(-1).operator === null) {
        showOperatorsMenu.value = true;
      } else if (result.value.at(-1).rightOperand === null) {
        showValueMenu.value = true;
        valueElement.value.focus();
      } else {
        showAndOrMenu.value = true;
      }
    };

    const closeMenu = () => {
      showOperandsMenu.value = false;
      showValueMenu.value = false;
      showOperatorsMenu.value = false;
      showAndOrMenu.value = false;
    };

    const calculateResult = (type, value) => {
      switch (type) {
        case "operand":
          result.value.push({
            leftOperand: value,
            operator: null,
            rightOperand: null,
            next: null,
          });
          showOperandsMenu.value = false;
          showOperatorsMenu.value = true;
          break;
        case "operator":
          result.value.at(-1).operator = value;
          showOperatorsMenu.value = false;
          showValueMenu.value = true;
          break;
        case "value":
          if (value) {
            result.value.at(-1).rightOperand = value;
            valueModel.value = "";
            showValueMenu.value = false;
          }
          break;
        case "ANDOR":
          result.value.at(-1).next = value;
          showAndOrMenu.value = false;
      }
    };

    const removeResultItem = (item) => {
      closeMenu();
      result.value = result.value.filter((x) => {
        if (x.leftOperand === item.leftOperand)
          if (x.operator === item.operator) if (x.rightOperand === item.rightOperand) return false;
        return true;
      });
    };
    const backSpace = () => {
      closeMenu();
      if (result.value.at(-1).next) result.value.at(-1).next = null;
      else if (result.value.at(-1).rightOperand) result.value.at(-1).rightOperand = null;
      else if (result.value.at(-1).operator) result.value.at(-1).operator = null;
      else if (result.value.at(-1).leftOperand) result.value.at(-1).leftOperand = null;
    };

    const isActive = ref(false);
    watch(
      () => props.forceClose,
      (newValue, oldValue) => {
        if (newValue) {
          isActive.value = false;
          closeMenu();
          emit("close");
        }
      }
    );
    const toggleIsActive = () => {
      isActive.value = !isActive.value;

      if (isActive.value) emit("open");
      else emit("close");
    };
    const doSearch = () => {
      emit("doSearch", result.value);
    };

    const removeLastConjunction = () => {
      if (result.value.at(-1).next) {
        result.value.at(-1).next = null;
        closeMenu();
      }
    };
    return {
      currentOperands,
      showOperandsMenu,
      currentOperators,
      showOperatorsMenu,
      showValueMenu,
      valueModel,
      valueElement,
      showAndOrMenu,
      result,
      calculateResult,
      removeResultItem,
      openMenu,
      closeMenu,
      backSpace,
      isActive,
      toggleIsActive,
      doSearch,
      removeLastConjunction,
    };
  },
};
</script>

<style>
.operand-menu {
  position: absolute;
  z-index: 40;
  left: 32px;
  width: 250px;
  background-color: white;
}

.hide {
  display: none;
}

.show {
  display: block;
}

.operand-menu ul {
  list-style: none;
  padding: 16px;
  border-radius: 5px;
  /*box-shadow: 0 30px 40px -20px hsl(229, 6%, 66%);*/
  -webkit-box-shadow: 10px 10px 17px -3px rgba(0, 0, 0, 0.71);
  box-shadow: 10px 10px 17px -3px rgba(0, 0, 0, 0.71);
}

.operand-menu li {
  height: 32px;
  padding: 8px;
  border-radius: 5px;
}

.operand-menu li:hover {
  background-color: #d9d9d9;
  cursor: pointer;
}

.result {
  min-height: 50px;
  min-width: 100px;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #525252;
  display: flex;
  flex-wrap: wrap;
  padding: 8px 100px 8px 8px;
}

.result-item {
  display: flex;
  padding-top: 2px;
  padding-bottom: 2px;
}

.result-item-body {
  padding: 4px;
  border-radius: 2px;
  background-color: #e8e8e8;
}

.result-item-body > span {
  margin-right: 2px;
}

.result-item-next {
  margin: 0 4px;
  padding: 4px;
  border-radius: 2px;
  background-color: #e8e8e8;
}

.round-button {
  min-width: 8px;
  max-width: 120px;
  text-decoration: none;
  display: inline-block;
  outline: none;
  cursor: pointer;
  border-style: none;
  color: #737373;
  background-color: white;
  border-radius: 100%;
  text-align: center;
}

.round-button:before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  padding-top: 100%;
}

span {
  display: inline-block;
  vertical-align: middle;
  max-width: 90%;
}

.round-button:active {
  background-color: #a8a8a8;
}

.round-button:hover {
  background-color: #cbcbcb;
}

.delete-button {
  width: 18px;
  margin-left: 4px;
  background-color: #e8e8e8;
}

.clear-button {
  width: 20px;
  height: 18px;
  align-self: center;
  right: 140px;
  position: relative;
  z-index: 100;
}

.clear-button:hover {
  color: white;
}

.value-menu {
  position: absolute;
  background-color: white;
  padding: 16px;
  width: 250px;
  border-radius: 5px;
  z-index: 10;
  left: 32px;
  -webkit-box-shadow: 10px 10px 17px -3px rgba(0, 0, 0, 0.71);
  box-shadow: 10px 10px 17px -3px rgba(0, 0, 0, 0.71);
}

.value-menu input {
  padding: 8px;
  width: 93%;
  direction: ltr;
}

.value-menu label {
  display: block;
  padding-bottom: 8px;
}

.value-menu div {
  direction: rtl;
  width: 100%;
}

.menu {
  position: absolute;
  background-color: white;
  color: black;
  padding: 16px;
  z-index: 10;
  right: 70px;
  border-radius: 4px;
  box-shadow: 0 12px 20px -10px rgba(156, 39, 176, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12),
    0 7px 8px -5px rgba(156, 39, 176, 0.2);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@-moz-document url-prefix() {
  .delete-button {
    width: 16px;
  }
  .clear-button {
    width: 18px;
  }
}

@media only screen and (max-width: 576px) {
  .result {
    padding-right: 40px;
  }
}
@media only screen and (max-width: 992px) {
  .result {
    padding-right: 55px;
  }
}
@media only screen and (max-width: 1200px) {
  .result {
    padding-right: 65px;
  }
}
</style>
